import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { ref, onValue } from "firebase/database";

const PrincipleForm = () => {
  const [selectedType, setSelectedType] = useState(""); // "class" or "teacher"
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedDivision, setSelectedDivision] = useState("");
  const [selectedTeacher, setSelectedTeacher] = useState("");
  const [timetableData, setTimetableData] = useState([]);
  const [classOptions, setClassOptions] = useState([]);
  const [divisionOptions, setDivisionOptions] = useState([]);
  const [teacherOptions, setTeacherOptions] = useState([]);
  const [periods, setPeriods] = useState([]);
  const [numberOfPeriods, setNumberOfPeriods] = useState(0);
  const [isLoading, setIsLoading] = useState(false); // Loading state
  const weekdays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const [currentTimetable, setCurrentTimetable] = useState({});
  const [isFieldsVisible, setIsFieldsVisible] = useState(false);
  const udiseNumber = localStorage.getItem("udiseNumber");
  const [boardType, setBoardType] = useState(localStorage.getItem("boardType") || ""); // Add boardType state
  const [allTimetables, setAllTimetables] = useState({});
const [isAllClassTimetable, setIsAllClassTimetable] = useState(false); // New state variable

  // Fetch class options
  useEffect(() => {
    setIsLoading(true);
    const timeRef = ref(db, `schoolRegister/${udiseNumber}/periodAssign/`);
    onValue(timeRef, (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.val();
        const classNames = Object.keys(data);
        setClassOptions(classNames);
      } else {
        setClassOptions([]);
      }
      setIsLoading(false);
    });
  }, []);


  useEffect(() => {
    if (selectedClass) {
      setIsLoading(true);
      const timeRef = ref(db, `schoolRegister/${udiseNumber}/periodAssign/${selectedClass}`);
      onValue(timeRef, (snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.val();
          setDivisionOptions(Object.keys(data));
        } else {
          setDivisionOptions([]);
        }
        setIsLoading(false);
      });
    }
  }, [selectedClass]);

  useEffect(() => {
    setIsLoading(true);
    const periodsRef = ref(db, `schoolRegister/${udiseNumber}/periods/`);
    onValue(periodsRef, (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.val();
        setNumberOfPeriods(data.numberOfPeriods || 0);
        const periodsArray = Array.from({ length: data.numberOfPeriods || 0 }, (_, i) => `${i + 1}`);
        setPeriods(periodsArray);
      }
      else{
        setNumberOfPeriods(7 || 0);
        const periodsArray = Array.from({ length: 7 || 0 }, (_, i) => `${i + 1}`);
        setPeriods(periodsArray);
      }
      setIsLoading(false);
    });
  }, []);

  // Fetch all unique teachers
  useEffect(() => {
    setIsLoading(true);
    const teacherRef = ref(db, `AttendanceData/${udiseNumber}/AttData`);
    onValue(teacherRef, (snapshot) => {
      if (snapshot.exists()) {
        const teachersData = snapshot.val();
        const teacherList = [];
        Object.keys(teachersData).forEach((mobileNumber) => {
          const teacher = teachersData[mobileNumber];
          if (teacher?.Name) {
            teacherList.push(teacher.Name);
          }
        });
        setTeacherOptions(teacherList);
      } else {
        setTeacherOptions([]);
      }
      setIsLoading(false);
    });
  }, [udiseNumber]);

  // Fetch timetable data for selected class and division
  useEffect(() => {
    
 if (selectedClass === "All") {
    setIsLoading(true);
    const timeRef = ref(db, `schoolRegister/${udiseNumber}/periodAssign`);
    onValue(timeRef, (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.val();
        const allTimetableData = {};
        Object.keys(data).forEach((cls) => {
          Object.keys(data[cls]).forEach((div) => {
            const teacherData = data[cls][div];
            const timetable = {};
            weekdays.forEach((day) => {
              timetable[day] = {};
              periods.forEach((p) => {
                timetable[day][p] = { subject: "-", teacher: "-", time: "-" };
              });
            });
            Object.keys(teacherData).forEach((teacherName) => { 
              Object.keys(teacherData[teacherName]).forEach((day) => {
                Object.keys(teacherData[teacherName][day]).forEach((periodNo) => {
                  const periodEntry = teacherData[teacherName][day][periodNo];
                  timetable[day][periodNo] = {
                    subject: periodEntry.subject || "-",
                    teacher: periodEntry.teacher || "-",
                    time: periodEntry.startTime && periodEntry.endTime
                      ? `${periodEntry.startTime} - ${periodEntry.endTime}`
                      : "-"
                  };
                });
              });
            });
            allTimetableData[`${cls}-${div}`] = timetable;
          });
        });
        setAllTimetables(allTimetableData);
     }
      setIsLoading(false);
    })
     } else if (selectedClass && selectedDivision && (boardType !== "icse" ||  boardType !== "cbse" ) ) {
      setIsLoading(true);
      const timeRef = ref(db, `schoolRegister/${udiseNumber}/periodAssign/${selectedClass}/${selectedDivision}`);
      onValue(timeRef, (snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.val();
          const formattedTimetable = {};
          let maxPeriodsLocal = 0;
          const formattedData = [];

          // Format data to include empty slots for unfilled periods
          weekdays.forEach((weekday) => {
            formattedTimetable[weekday] = {};

            // Fill all periods with default empty data
            periods.forEach((period) => {
              formattedTimetable[weekday][period] = {
                subject: "-",
                teacher: "-",
                time: "-",
              };
            });
          });

          // Populate timetable with actual data from Firebase
          Object.keys(data).forEach((teacher) => {
            const teacherData = data[teacher];
            Object.keys(teacherData).forEach((weekday) => {
              const weekdayData = teacherData[weekday];
              Object.keys(weekdayData).forEach((period) => {
                const periodNumber = parseInt(period, 10);
                const { subject, teacher, startTime, endTime } = weekdayData[period];

                formattedTimetable[weekday][periodNumber] = {
                  subject: subject || "-",
                  teacher: teacher || "-",
                  time: startTime && endTime ? `${startTime} - ${endTime}` : "-",
                };
              });
            });
          });

          setCurrentTimetable(formattedTimetable);
          setIsFieldsVisible(true);
        } else {
          setCurrentTimetable({});
          setIsFieldsVisible(false);
        }
        setIsLoading(false);
      });
    } else {
      setCurrentTimetable({});
      setIsFieldsVisible(false);
    }
  }, [selectedClass, selectedDivision, boardType, periods]);

  useEffect(() => {
    if (selectedTeacher && (boardType !== "icse" || boardType !== "cbse")) {
      setIsLoading(true);
      const timetableRef = ref(db, `schoolRegister/${udiseNumber}/periodAssign`);
      onValue(timetableRef, (snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.val();
          const formattedData = [];

          Object.keys(data).forEach((cls) => {
            Object.keys(data[cls]).forEach((div) => {
              if (data[cls][div][selectedTeacher]) {
                Object.keys(data[cls][div][selectedTeacher]).forEach((day) => {
                  const periods = data[cls][div][selectedTeacher][day];
                  Object.keys(periods).forEach((periodName) => {
                    formattedData.push({
                      day,
                      period: periodName,
                      subject: periods[periodName].subject,
                      startTime: periods[periodName].startTime,
                      endTime: periods[periodName].endTime,
                      class: cls,
                      division: div,
                    });
                  });
                });
              }
            });
          });

          setTimetableData(formattedData);
        } else {
          setTimetableData([]);
        }
        setIsLoading(false);
      });
    } else {
      setTimetableData([]);
    }
  }, [selectedTeacher, boardType]);

  const handleTeacherChange = (e) => {
    setSelectedTeacher(e.target.value);
  };

  const handleClassChange = (e) => {
    setSelectedClass(e.target.value);
     setIsAllClassTimetable(e.target.value === "All");
  };

  const handleDivisionChange = (e) => {
    setSelectedDivision(e.target.value);
  };

   const printStyles = `
    @media print {
      body * {
        visibility: hidden;
      }
      #print-content, #print-content * {
        visibility: visible;
      }
      #print-content {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
      }
      .no-print {
        display: none !important;
      }
      @page {
        size: legal landscape;
        margin: 5mm;
      }
      table {
        width: 100%;
        border-collapse: collapse;
        page-break-inside: avoid;
        font-size: 10pt;
      }
      th, td {
        border: 1px solid #000;
        padding: 3px;
        text-align: center;
      }
      th {
        background-color:rgb(65, 143, 29) !important;
      }
      h3 {
        margin: 5px 0;
        page-break-after: avoid;
      }
    }
  `;

  // Modified handlePrint function
  const handlePrint = () => {
    const printContent = document.getElementById("print-content").outerHTML;
    const originalContent = document.body.innerHTML;
    
    document.body.innerHTML = `
      <style>${printStyles}</style>
      <div id="print-content">
        ${printContent}
      </div>
    `;
    
    window.print();
    document.body.innerHTML = originalContent;
  };

  // Render timetable for class/division
  const renderClassTimetable = () => {
    return weekdays.map((weekday) => (
      <tr key={weekday}>
        <td style={{fontSize:'14px', padding:'10px', border:'1px solid gray'}}>{weekday}</td>
        {periods.map((period, colIndex) => {
          const periodData = currentTimetable[weekday]?.[period];
          return (
            <td style={{border:'1px solid gray'}} key={colIndex}>
              {periodData && periodData.subject !== "-" ? (
                <>
                  <div style={{fontSize:'14px'}}><b>{periodData.subject}</b></div>
                  <div style={{fontSize:'12px'}}>{periodData.teacher}</div>
                  <div style={{fontSize:'14px', color:'#cf3030'}}>{periodData.time}</div>
                </>
              ) : (
                "-"
              )}
            </td>
          );
        })}
      </tr>
    ));
  };

  const renderTeacherTimetable = () => {
    return weekdays.map((weekday) => (
      <tr key={weekday}>
        <td  style={{fontSize:'14px', padding:'10px', border:'1px solid gray'}}>{weekday}</td>
        {periods.map((period, colIndex) => {
          const periodData = timetableData.find((item) => item.day === weekday && item.period === period);
          return (
            <td style={{border:'1px solid gray'}} key={colIndex}>
              {periodData ? (
                <>
                  <div style={{fontSize:'14px'}}><b>{periodData.subject}</b></div>
                  <div style={{fontSize:'12px'}}>{periodData.class} {boardType !== "ICSE" ? periodData.division :  "DVCO"}</div>
                  <div style={{fontSize:'14px'}}>{periodData.startTime} - {periodData.endTime}</div>
                </>
              ) : (
                "-"
              )}
            </td>
          );
        })}
      </tr>
    ));
  };
  useEffect(() => {
    if (selectedType === "daywise" && boardType !== "ICSE") {
      setIsLoading(true);
      const timeRef = ref(db, `schoolRegister/${udiseNumber}/periodAssign`);
      onValue(timeRef, (snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.val();
          const allData = {};
  
          Object.keys(data).forEach((className) => {
            Object.keys(data[className]).forEach((divisionName) => {
              const fullName = divisionName!=='-' ? `${className}-${divisionName}` : `${className}`;
              
              const teacherData = data[className][divisionName];
              
              // Initialize the timetable structure
              const timetable = {};
              weekdays.forEach((day) => {
                timetable[day] = {};
                periods.forEach((p) => {
                  timetable[day][p] = { subject: "-", teacher: "-", time: "-" };
                });
              });
  
              Object.keys(teacherData).forEach((teacherName) => {
                Object.keys(teacherData[teacherName]).forEach((day) => {
                  Object.keys(teacherData[teacherName][day]).forEach((periodNo) => {
                    const periodEntry = teacherData[teacherName][day][periodNo];
                    timetable[day][periodNo] = {
                      subject: periodEntry.subject || "-",
                      teacher: periodEntry.teacher || "-",
                      time: periodEntry.startTime && periodEntry.endTime
                        ? `${periodEntry.startTime} - ${periodEntry.endTime}`
                        : "-"
                    };
                  });
                });
              });
  
              allData[fullName] = timetable;
            });
          });
  
          setAllTimetables(allData);
        } else {
          setAllTimetables({});
        }
        setIsLoading(false);
      });
    }
  }, [selectedType, boardType, periods]);
  
  const renderDaywiseTables = () => {
    return weekdays.map((day) => {
      // Check if at least one subject exists on this day
      const hasData = Object.values(allTimetables).some((classTimetable) => {
        return Object.values(classTimetable[day] || {}).some((periodData) => periodData?.subject && periodData.subject !== "-");
      });
  
      if (!hasData) return null; // Skip rendering if no data for this day
  
      return (
        <div key={day} style={{ marginBottom: "40px" }}>
          <h3 style={{ textAlign: "center", color: "#2f792f" }}>{day}</h3>
          <table style={{ borderCollapse: "collapse", width: "100%", backgroundColor: "#f9f9f9" }}>
            <thead>
              <tr>
                <th style={{ border: "1px solid gray", backgroundColor: "#2f792f", color: "white", padding: "10px" }}>Class</th>
                {periods.map((p) => (
                  <th key={p} style={{ border: "1px solid gray", backgroundColor: "#2f792f", color: "white", padding: "10px" }}>Period {p}</th>
                ))}
              </tr>
            </thead>
            <tbody>
  {Object.keys(allTimetables).map((classDiv) => {
    const classDayData = allTimetables[classDiv]?.[day];

    // Check if any period has a real subject (i.e., not "-")
    const hasAnyPeriodAssigned = Object.values(classDayData || {}).some(
      (entry) => entry?.subject && entry.subject !== "-"
    );

    if (!hasAnyPeriodAssigned) return null; // Skip this row entirely

    return (
      <tr key={classDiv}>
        <td style={{ border: "1px solid gray", padding: "10px", fontWeight: "bold" }}>{classDiv}</td>
        {periods.map((p) => {
          const entry = classDayData?.[p];
          return (
            <td key={p} style={{ border: "1px solid gray", padding: "8px", fontSize: "13px" }}>
              {entry?.subject && entry.subject !== "-" ? (
                <>
                  <div><strong>{entry.subject}</strong></div>
                  <div>{entry.teacher}</div>
                  <div style={{ color: "#cf3030" }}>{entry.time}</div>
                </>
              ) : ""}
            </td>
          );
        })}
      </tr>
    );
  })}
</tbody>

          </table>
        </div>
      );
    });
  };
  
  const renderAllTimetables = () => {
    return (
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
        gap: '10px',
        fontSize: '10px'
      }}>
        {Object.keys(allTimetables).map((classDiv) => {
          const classDayData = allTimetables[classDiv];

          return (
            <div key={classDiv} style={{ 
              margin: "5px", 
              breakInside: 'avoid',
              pageBreakInside: 'avoid'
            }}>
              <h3 style={{ 
                textAlign: "center", 
                color: "#2f792f",
                fontSize: '12px',
                margin: '5px 0'
              }}>
                {classDiv}
              </h3>
              <table style={{ 
                borderCollapse: "collapse", 
                width: "100%", 
                backgroundColor: "#f9f9f9",
                fontSize: '10px'
              }}>
                <thead>
                  <tr>
                    <th style={{ 
                      border: "1px solid gray", 
                      backgroundColor: "#2f792f", 
                      color: "white", 
                      padding: "3px",
                      fontSize: '10px'
                    }}>
                      Day
                    </th>
                    {periods.map((p) => (
                      <th key={p} style={{ 
                        border: "1px solid gray", 
                        backgroundColor: "#2f792f", 
                        color: "white", 
                        padding: "3px",
                        fontSize: '10px'
                      }}>
                        P{p}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {weekdays.map((day) => (
                    <tr key={day}>
                      <td style={{ 
                        fontSize: '10px', 
                        padding: '5px', 
                        border: '1px solid gray',
                        fontWeight: 'bold'
                      }}>
                        {day.slice(0,3)}
                      </td>
                      {periods.map((period) => {
                        const periodData = classDayData[day]?.[period];
                        return (
                          <td style={{ 
                            border: '1px solid gray',
                            padding: '3px'
                          }} key={period}>
                            {periodData && periodData.subject !== "-" ? (
                              <>
                                <div style={{ fontSize: '9px' }}>
                                  <b>{periodData.subject}</b>
                                </div>
                                <div style={{ fontSize: '8px' }}>
                                  {periodData.teacher}
                                </div>
                                <div style={{ 
                                  fontSize: '8px', 
                                  color: '#cf3030'
                                }}>
                                  {periodData.time}
                                </div>
                              </>
                            ) : (
                              "-"
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          );
        })}
      </div>
    );
  };



  return (
    <div className="main-content-of-page" style={{ display: "flex", flexDirection: "column"}}>
      <div style={{ padding: "20px" }}>
        <h2 style={{ fontFamily: "Arial, sans-serif", marginBottom: "20px", textAlign: "center" }}>
          All Timetable
        </h2>
        <h3 id="print-heading" style={{ textAlign: "center" }}></h3> {/* Add this line */}
        <form style={{ margin:"auto",display: "flex", flexDirection: "column", gap: "10px", marginBottom: "20px", maxWidth:'600px', boxShadow:'2px 1px 9px 2px gray', padding:'20px'}}>
          <label className="no-print" style={{ fontWeight: "bold" }}>Select Type:</label>
          <select
            className="no-print"
            onChange={(e) => setSelectedType(e.target.value)}
            value={selectedType}
            style={{ padding: "5px", border: "1px solid #ccc", borderRadius: "5px" }}
          >
            <option value="">--Select--</option>
            <option value="class">Class</option>
            <option value="teacher">Teacher</option>
            <option value="daywise">Day Wise</option>

          </select>

          {selectedType === "class" && (
            <>
              <label className="no-print" style={{ fontWeight: "bold" }}>Select Class:</label>
              <select
                className="no-print"
                onChange={handleClassChange}
                value={selectedClass}
                style={{ padding: "5px", border: "1px solid #ccc", borderRadius: "5px" }}
              >
                <option value="">--Select Class--</option>
                <option value="All">All</option>
                {classOptions.map((className) => (
                  <option key={className} value={className}>
                    {className}
                  </option>
                ))}
              </select>

              <label className="no-print" style={{ fontWeight: "bold" }}>Select Division:</label>
              <select
                className="no-print"
                onChange={handleDivisionChange}
                value={selectedDivision}
                style={{ padding: "5px", border: "1px solid #ccc", borderRadius: "5px" }}
              >
                <option value="">--Select Division--</option>
                {divisionOptions.map((division) => (
                  <option key={division} value={division}>
                    {division}
                  </option>
                ))}
              </select>
            </>
          )}

          {selectedType === "teacher" && (
            <>
              <label className="no-print" style={{ fontWeight: "bold" }}>Select Teacher:</label>
              <select
                className="no-print"
                onChange={handleTeacherChange}
                value={selectedTeacher}
                style={{ padding: "5px", border: "1px solid #ccc", borderRadius: "5px" }}
              >
                <option value="">--Select Teacher--</option>
                {teacherOptions.map((teacher) => (
                  <option key={teacher} value={teacher}>
                    {teacher}
                  </option>
                ))}
              </select>
            </>
          )}
        </form>
         <button 
        onClick={handlePrint} 
        className="no-print"
        style={{ 
          padding: "8px 15px", 
          backgroundColor: "#2f792f", 
          color: "white", 
          border: "none", 
          borderRadius: "5px", 
          cursor: "pointer", 
          margin: "10px 0",
          fontSize: '14px'
        }}
      >
        Print Timetable
      </button>
        <div id="print-content">
        {selectedType === "daywise" && (boardType !== "icse" || boardType !== "cbse")? (
  renderDaywiseTables()
) : (selectedType === "class" && selectedClass && selectedDivision && (boardType !== "icse" || boardType !== "cbse") ) ||
   (selectedType === "teacher" && selectedTeacher && (boardType !== "icse" || boardType !== "cbse")) ? (

            <>
            <h5>{selectedType === "class"  && (
              <>
              <span>Class:- {selectedClass} {" "} {selectedDivision}</span>
              </>
            )}
            
            {selectedType === "teacher"  && (
              <>
              <span>Teacher:- {selectedTeacher} </span>
              </>
            )}
            </h5>
            <table style={{ borderCollapse: "collapse", height: "100%", overflowX: "auto", mwidth: "100%", textAlign: "center", backgroundColor: "#f9f9f9", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.4)"}}>
              <thead>
                <tr>
                  <th style={{ padding: "7px", backgroundColor: "#2f792f", color: "white", border: "1px solid gray", textAlign: "center", minWidth: "120px" }}>Day</th>
                  {periods.map((period) => (
                    <th key={period} style={{ padding: "7px", backgroundColor: "#2f792f", color: "white", border: "1px solid gray", textAlign: "center", minWidth: "120px" }}>
                      Period {period}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {selectedType === "teacher" ? renderTeacherTimetable() : renderClassTimetable()}
              </tbody>
            </table>
             </>
            ) : (selectedType === "class" && selectedClass === "All") ? (
              renderAllTimetables() // Render all timetables when "All" is selected
            ) : isLoading ? (
              <p>Loading...</p>
            ) : (
              <p>No data available</p>
            )}
          </div>

         <style>{`
        th, td {
          width: auto;
        }
        ${isAllClassTimetable ? `
          @media print {
            @page {
              size: A3 landscape;
              margin: 0;
            }
            body {
              margin: 0;
              padding: 0;
            }
            .main-content-of-page {
              display: flex;
              flex-direction: column;
              align-items: center;
            }
            #print-content {
              display: flex;
              flex-wrap: wrap;
              justify-content: space-around;
            }
            table {
              page-break-inside: avoid;
              margin: 10px;
              border-collapse: collapse;
              width: auto; /* Adjust width for printing */
            }
            th, td {
              border: 1px solid gray;
              padding: 5px;
              text-align: center;
            }
          }
        ` : ''}
      `}</style>
      
      </div>
    </div>
  );
};
export default PrincipleForm;